import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgxAimStationSelectStation } from './ngx-aim-station-select-station.class';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { StationImagePipe } from '../../../pipes';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ngx-aim-station-select-station',
  standalone: true,
  imports: [ButtonModule, RouterLink, ProgressSpinnerModule, StationImagePipe, NgClass],
  templateUrl: './ngx-aim-station-select-station.component.html',
  styleUrl: './ngx-aim-station-select-station.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimStationSelectStationComponent extends NgxAimStationSelectStation implements OnInit {
  ngOnInit() {
    this.init();
  }
}
